import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StudentCourseProgressResponse, StudentProgressCourseData } from '@edtech-ui/core/models/student-courses-v2/student-course-detail-progress';
import { StudentDashboardStatsResponse } from '@edtech-ui/core/models/student-courses-v2/student-dashboard-stats';
import { StudentCourseEnrollmentResponse } from '@edtech-ui/core/models/student-courses-v2/student-enroll-courses';
import { StudentMyLearningEnrolledCoursesResponse } from '@edtech-ui/core/models/student-courses-v2/student-enroll-my-courses';
import { StudentPublishedCoursesResponse } from '@edtech-ui/core/models/student-courses-v2/student-get-all-published-courses';
import { StudentQuizChallengesResponse } from '@edtech-ui/core/models/student-courses-v2/student-quiz-challanges';
import { StudentTopicCourseEnrollmentResponse, StudentTopicProgressPayload } from '@edtech-ui/core/models/student-courses-v2/student-topic-progress';
import { environment } from 'environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class StudentCoursesService {

	apiUrl = environment.studentCourseApiUrl;

	private courseDetailsSubject = new BehaviorSubject<StudentProgressCourseData | null>(null);
	courseDetails$ = this.courseDetailsSubject.asObservable();

	constructor(private http: HttpClient) { }

	setCourseDetails(data: StudentProgressCourseData): void {
		this.courseDetailsSubject.next(data);
	}

	getStudentDashboardStats(): Observable<StudentDashboardStatsResponse> {
		return this.http.get<StudentDashboardStatsResponse>(`${this.apiUrl}/dashboard/stats`);
	}

	getAllStudentPublishedCourses(classId: number, page = 1, pageSize = 10): Observable<StudentPublishedCoursesResponse> {
		const params = new HttpParams().set('page', page).set('page_size', pageSize);
		return this.http.get<StudentPublishedCoursesResponse>(`${this.apiUrl}/published-courses/${classId}`, { params })
	}

	postStudentEnroll(courseId: string): Observable<StudentCourseEnrollmentResponse> {
		return this.http.post<StudentCourseEnrollmentResponse>(`${this.apiUrl}/enroll`, { course_id: courseId })
	}

	getMyEnrollCourses(page = 1, limit = 10, statusFilter = ''): Observable<StudentMyLearningEnrolledCoursesResponse> {
		const params = new HttpParams().set('page', page).set('limit', limit).set('status_filter', statusFilter);
		return this.http.get<StudentMyLearningEnrolledCoursesResponse>(`${this.apiUrl}/my-courses`, { params })
	}

	patchTopicProgress(courseId: string, payload: StudentTopicProgressPayload): Observable<StudentTopicCourseEnrollmentResponse> {
		return this.http.patch<StudentTopicCourseEnrollmentResponse>(`${this.apiUrl}/courses/${courseId}/progress`, payload);
	}

	getStudentCoursesProgress(courseId: string): Observable<StudentCourseProgressResponse> {
		return this.http.get<StudentCourseProgressResponse>(`${this.apiUrl}/courses/${courseId}/details`);
	}

	getStudentQuizChallenges(courseId: string, page = 1, limit = 10): Observable<StudentQuizChallengesResponse> {
		const params = new HttpParams().set('page', page).set('limit', limit);
		return this.http.get<StudentQuizChallengesResponse>(`${this.apiUrl}/courses/${courseId}/quiz-challenges`, { params });
	}

}